





































import { Component, Prop, Vue } from "vue-property-decorator";
import { StoreUseData } from "@/@types/store";
import { SceneAndLayer, SceneLayer } from "@/@types/room";
import GameObjectManager from "@/app/basic/GameObjectManager";
import SCheck from "@/app/basic/common/components/SCheck.vue";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({ components: { SCheck } })
export default class EditSceneLayerComponent extends Vue {
  @Prop({ type: Object, required: true })
  private layerInfo!: SceneLayer;

  @Prop({ type: Boolean, required: true })
  private dragMode!: boolean;

  @Prop({ type: String, default: "" })
  private value!: string; // selectedLayerId

  @Prop({ type: Boolean, required: true })
  private isOrderChanging!: boolean;

  public input(value: string) {
    this.$emit("input", value);
  }

  private get localValue(): string {
    return this.value;
  }

  private set localValue(value: string) {
    this.input(value);
  }

  @VueEvent
  private get sceneAndLayerInfo(): (id: string) => StoreUseData<SceneAndLayer> {
    return (id: string) =>
      this.sceneAndLayerList.filter(sal => sal.data!.layerId === id)[0];
  }

  @VueEvent
  private onHoverView(isHover: boolean) {
    if (isHover) this.$emit("onMouseHoverView", true);
    else {
      if (this.dragMode) this.$emit("onMouseHoverOrder", true);
      else this.$emit("onMouseHoverView", false);
    }
  }

  private sceneAndLayerList = GameObjectManager.instance.sceneAndLayerList;
}
